'use strict'

import _ from 'lodash'

export function formService (http) {
	return {
		findControlTextByKey: (control, key, controls) => {
			key = (control === 'y/n' && key === '') ? 'F' : key
			const valObj = _.find(controls[control], {value: key})
			let out = null

			if (key !== '' && valObj) {
				out = valObj.text
			} else if (key !== '' && !_.isNil(controls[control])) {
				out = key
			} else {
				out = 'No value selected'
				if (key !== '') {
					console.log('Unable to find control', control, 'with key', key)
				}
			}
			return out
		},

		// Load control data depending on form [name]
		findControlByForm: (formName, takeoff) => {
			if (_.isNil(takeoff)) {
				takeoff = 'all'
			}
			return http.jsonrpc(
				'/rpc/2.0/form',
				'findControlByForm',
				[ formName, takeoff ]
			).then((resp) => {
				return resp.result
			})
		},

		// Load control labels by [name]
		findOptionsLabelsByName: (options) => {
			return http.jsonrpc(
				'/rpc/2.0/form',
				'findOptionsLabelsByName',
				[ options ]
			).then((resp) => {
				return resp.result
			})
		},

		controlArrayToObject: (controlArray) => {
			const values = _.mapKeys(controlArray, (value) => {
				return value.value
			})
			return values
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/e24-services/form-service.js